import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { SettingsProvider } from "./lib/settings";
import PublicLayout from "./components/PublicLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import AndroidUpdateBanner from "./components/AndroidUpdateBanner";

import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Portfolio from "./pages/Portfolio";
import PortfolioDetail from "./pages/PortfolioDetail";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Guides from "./pages/Guides";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Checkout from "./pages/Checkout";

import CustomerLayout from "./pages/customer/CustomerLayout";
import MyOrders from "./pages/customer/MyOrders";
import CustomerInbox from "./pages/customer/CustomerInbox";
import OrderDetail from "./pages/customer/OrderDetail";
import RequirementsForm from "./pages/customer/RequirementsForm";
import Downloads from "./pages/customer/Downloads";
import Account from "./pages/customer/Account";
import MyReviews from "./pages/customer/MyReviews";

import DesignerPages from "./pages/DesignerPages";
import AdminPages from "./pages/AdminPages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <AndroidUpdateBanner />
          <Routes>
            {/* Public site */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/portfolio/:id" element={<PortfolioDetail />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/checkout/:slug" element={<Checkout />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Customer dashboard */}
            <Route path="/dashboard" element={
              <ProtectedRoute roles={["customer", "admin"]}>
                <CustomerLayout />
              </ProtectedRoute>
            }>
              <Route index element={<MyOrders />} />
              <Route path="inbox" element={<CustomerInbox />} />
              <Route path="orders/:id" element={<OrderDetail />} />
              <Route path="requirements/:orderId" element={<RequirementsForm />} />
              <Route path="downloads" element={<Downloads />} />
              <Route path="reviews" element={<MyReviews />} />
              <Route path="account" element={<Account />} />
            </Route>

            {/* Designer */}
            <Route path="/designer/*" element={
              <ProtectedRoute roles={["designer"]}>
                <DesignerPages />
              </ProtectedRoute>
            } />

            {/* Admin */}
            <Route path="/admin/*" element={
              <ProtectedRoute roles={["admin"]}>
                <AdminPages />
              </ProtectedRoute>
            } />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
